window.devMode = false;

if(navigator && navigator.serviceWorker)
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
        for(let registration of registrations) {
            registration.unregister()
        } })

import 'promise-polyfill/src/polyfill';
import './styles/main.scss';

import Vue from 'vue'
import Vuetify from 'vuetify';
import router from './router'
import store from './store'
import Main from './Main';
import prune from './../public/libraries/prune'

JSON.prune = prune;
import Notify from './additionalClass/Notify';
import Notification from './additionalClass/Notification';
import Chat from "./additionalClass/Chat/Chat";
import AuthMiddleware from './additionalClass/AuthMiddleware';
import Validator from './additionalClass/Validator';

window.axios = require('axios');
window.bowser = require('bowser');
window.AuthMiddleware = new AuthMiddleware();
window.Validator = Validator;
window.notify = new Notify();               // show local notfiy
window.Notification = new Notification();   // notification from serwer
window.Chat = new Chat();                    // notification from serwer

window.axios.defaults.baseURL = window.devMode ? 'http://cmcapi.pl' : 'https://api.centrumklubu.pl';
window.axios.defaults.headers.post['Content-Type'] = 'application/json';
window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if(error.response.data && error.response.data.error){
        window.notify.createNotifier(error.response.data.error,"danger",5000);
        return Promise.reject(error);
    }
});

Vue.config.productionTip = false
Vue.use(Vuetify);

Vue.mixin({
    methods: {
        go(url) {
            this.$router.push(url);
        },
        showModal(name) {
            $(name).showModal()
        },
        hideModal(name) {
            $(name).hideModal()
        }
    }
});

new Vue({
    router,
    el: '#app',
    store,
    render (h) {
        return h(Main, this.hi)
    }
})
